import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ToolbarComponent } from './toolbar/toolbar.component';
import { ToolbarScopeComponent } from './toolbar-scope/toolbar-scope.component';
import { ToolbarNavigationComponent } from './toolbar-navigation/toolbar-navigation.component';
import { ToolbarProfileComponent } from './toolbar-profile/toolbar-profile.component';
import { ToolbarMenuComponent } from './toolbar-menu/toolbar-menu.component';

@NgModule({
  declarations: [
    ToolbarComponent,
    ToolbarScopeComponent,
    ToolbarNavigationComponent,
    ToolbarProfileComponent,
    ToolbarMenuComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
  ],
  exports: [ToolbarComponent],
})
export class ToolbarModule {}
